<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ managementCompanyName }}</span>
		<app-button
			(click)="create()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			>Create</app-button
		>
	</div>
</ng-template>

<ng-template #condoCorporationManagementTemplate let-item>
	<div class="flex flex-col">
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>

<div class="py-2">
	<app-auto-complete
		placeholder="Search Management Company"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: (condoCorporationManagements$ | async),
				template: condoCorporationManagementTemplate,
				title: 'Management Companies',
				noResultsMessage: 'No management company found',
				type: dropdownSelect.SELECT_CONDO_CORPORATION_MANAGEMENT,
			},
		]"
		[(ngModel)]="managementCompanyName"
		name="dual-dropdown-1"
		[minSearchTerm]="2"
		[loading]="loading"
		width="w-full"
		[label]="label"
		(debounce)="search($event)"
		(onSelect)="onSelectCondoCorporationManagement($event)"
	>
	</app-auto-complete>
</div>
